<template>
  <v-tooltip bottom color="black">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        :color="isItemUnsynced ? 'green' : 'blue'"
        >mdi-cloud-refresh</v-icon
      >
    </template>
    <span>{{ isItemUnsynced ? "Unsynced" : "Synced" }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SyncStateIcon',
  props: {
    isItemUnsynced: Boolean,
  },
};
</script>
